import { action, createRequestTypes } from '@/utils/actions.utils'
import { invoicesService } from '@/services'
import { uiActions } from '@/redux/actions'
import { ERROR_403_PATH } from '@/constants'

export const FETCH_INVOICES = createRequestTypes('FETCH_INVOICES')
const fetchInvoices = ({
	clientCode,
	search,
	sortBy,
	page,
	limit,
	resetList
}) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await invoicesService.fetchInvoices({
				clientCode,
				search,
				sortBy,
				page,
				limit,
				resetList
			})

			return dispatch(success(res.data))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_INVOICES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_INVOICES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_INVOICES.FAILURE, null, err)
	}
}

const invoicesActions = {
	fetchInvoices
}

export default invoicesActions
